import { __extends } from "tslib";
import { isDefined } from '@tyler-components-web/core';
import { AbstractComponentDelegate } from '../core/delegates/abstract-component-delegate';
import { TextFieldComponentDelegate } from '../text-field';
import { AUTOCOMPLETE_CONSTANTS } from './autocomplete-constants';
import { ICON_CONSTANTS } from '../icon';
var AutocompleteComponentDelegate = /** @class */ (function (_super) {
    __extends(AutocompleteComponentDelegate, _super);
    function AutocompleteComponentDelegate(config) {
        return _super.call(this, config) || this;
    }
    AutocompleteComponentDelegate.prototype.build = function () {
        var autocomplete = document.createElement(AUTOCOMPLETE_CONSTANTS.elementName);
        if (this._config.useDropdownIcon) {
            var dropdownIcon = document.createElement(ICON_CONSTANTS.elementName);
            dropdownIcon.slot = 'trailing';
            dropdownIcon.name = 'arrow_drop_down';
            dropdownIcon.setAttribute('tcw-dropdown-icon', '');
            if (!this._config.textFieldConfig) {
                this._config.textFieldConfig = {};
            }
            this._config.textFieldConfig.trailingElement = dropdownIcon;
        }
        this._textFieldDelegate = new TextFieldComponentDelegate(this._config.textFieldConfig);
        autocomplete.appendChild(this._textFieldDelegate.component);
        return autocomplete;
    };
    AutocompleteComponentDelegate.prototype.configure = function () {
        // Configure the autocomplete
        this._component.filter = this._config.filter;
        if (isDefined(this._config.multiple)) {
            this._component.multiple = this._config.multiple;
        }
        if (isDefined(this._config.debounce)) {
            this._component.debounce = this._config.debounce;
        }
        if (isDefined(this._config.filterOnFocus)) {
            this._component.filterOnFocus = this._config.filterOnFocus;
        }
        if (isDefined(this._config.allowUnmatched)) {
            this._component.allowUnmatched = this._config.allowUnmatched;
        }
        if (isDefined(this._config.optionLimit)) {
            this._component.optionLimit = this._config.optionLimit;
        }
        if (isDefined(this._config.optionBuilder)) {
            this._component.optionBuilder = this._config.optionBuilder;
        }
        if (isDefined(this._config.selectedTextBuilder)) {
            this._component.selectedTextBuilder = this._config.selectedTextBuilder;
        }
    };
    Object.defineProperty(AutocompleteComponentDelegate.prototype, "textFieldDelegate", {
        get: function () {
            return this._textFieldDelegate;
        },
        enumerable: true,
        configurable: true
    });
    AutocompleteComponentDelegate.prototype.getValue = function () {
        return this._component.value;
    };
    AutocompleteComponentDelegate.prototype.setValue = function (value) {
        this._component.value = value;
    };
    AutocompleteComponentDelegate.prototype.onChange = function (listener) {
        this._component.addEventListener(AUTOCOMPLETE_CONSTANTS.events.CHANGE, function (evt) { return listener(evt.detail); });
    };
    AutocompleteComponentDelegate.prototype.validate = function () {
        return this._component.value !== null;
    };
    return AutocompleteComponentDelegate;
}(AbstractComponentDelegate));
export { AutocompleteComponentDelegate };
